import { useEffect, useState } from 'react'
import Modal from './modal'
import modalsEventBus from './modals-event-bus'

export default function useQueuedModal(): Modal | null {
  const [modalsQueue, setModalsQueue] = useState<Modal[]>([])

  useEffect(() => {
    const onModalShow = (enqueuedModal: Modal) => {
      setModalsQueue(prevModalsQueue => [...prevModalsQueue, enqueuedModal])

      enqueuedModal.closeSignal.subscribe(() => {
        setModalsQueue(prevModalsQueue => prevModalsQueue.filter(modal => modal.id !== enqueuedModal.id))
      })
    }

    modalsEventBus.on('show', onModalShow)

    return () => modalsEventBus.off('show', onModalShow)
  })

  const shownModal = modalsQueue[0] ?? null

  return shownModal
}
